export const bullets = [
  "Your move-in checklist",
  "Installing a security system",
  "Organizing your cabinets",
  "Swapping out light fixtures",
  "Renovations (big and small)"
];
